import React, { useCallback, useEffect } from 'react';
import './Header.css';
import './index.css';
import { Spacer, DragNDropBriefcase, EmptyElement, BackButton, PageNotFound, Spacer100, Spacer10, DropResult, PDFViewer, SubmissionArea, Spacer25, LoadingDocs} from './Utils';
import strs from './strings';
import docsAll from './docs';
import Select from 'react-select';
import curCase from './testCase';
import { FormContext } from './context';
import { useMemo, useState } from 'react';
import { FullscreenDocument } from './Popups';
import { isInaccessible } from '@testing-library/react';
import { useMediaQuery } from '@mui/material';
import { getFirestoreDoc, setFirestoreDoc } from './firestore';
import { auth } from './firebase';
import { getFile } from './googleCloudStorage';
import { nanoid } from 'nanoid';
import { getDoc } from 'firebase/firestore';
import { DesktopDateTimePickerLayout } from '@mui/x-date-pickers';

const lang = strs.en;
const docsList = docsAll.en;
const colorStyles = {
	control: (styles) => ({
		...styles,
// 		color: 'black',
		backgroundColor: '#f5f6f7',
		border: '1px solid gray',
// 		minWidth: '636px',
		minHeight: '48px',
// 		margin: '1rem'
	}),
}


export default function Documents() {

	const [globalForm, setGlobalForm] = useState({docs: []})	
	const [isLoading, setIsLoading] = useState(true);
	const [iframeDoc, setIframeDoc] = useState('');
	const [isIframe, setIsIframe] = useState('hidden');
	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 756px)');
	const uid = auth.currentUser.uid;


	useEffect(() => {
		// Define an async function inside useEffect
		const fetchUrls = async () => {
		//TODO: catch this promise.
			let docsPromise = await getFirestoreDoc(`/documents/${uid}`)
			let docs = docsPromise.docs;
			console.log('firebaseDocs', docs)
			if (!docs?.length) {
				setIsLoading(false);
				return;
			}
			// Use Promise.all to handle multiple async operations
// 			const updatedDocs = await Promise.all(curCase.docs.map(async (doc) => {
// 				const response = await fetch(doc.url);
// 				const file = await response.blob();
// 				const url = URL.createObjectURL(file);
// 				doc.url = url;
// 				return doc; // Ensure to return doc for Promise.all
// 			}));
			const updatedDocs = await Promise.all(docs.map(async (doc) => {
				const file = await getFile(doc.uuid)
				const url = URL.createObjectURL(file);
				doc.url = url;
				return doc; // Ensure to return doc for Promise.all
			}));


			// Optionally, update state or perform other operations with updatedDocs
			console.log('after useEffect', updatedDocs);
			setGlobalForm({docs: [...updatedDocs]});
			setIsLoading(false)
		};

		fetchUrls(); // Call the async function

		console.log('docsList', docsList)

	}, [uid]); 



// 	const value = useMemo(
// 		() => ({globalForm, setGlobalForm}),
// 		[globalForm, setGlobalForm]
// 	)

	console.log('global form', globalForm)


	const [ formData, setFormData ] = React.useState({
		docType: null,
		doc: null,
		textArea: "",
	});
	const [uploadedFile, setUploadedFile] = React.useState(null);

	
	function handleChange (selectedOption) {
		setFormData({
			...formData,
			docType: selectedOption.value,
		})
		console.log('formData', formData);
	}


	async function uploadDoc() {
		console.log('doc', uploadedFile);
// 		setClientDocsState((prevDocs) => ([
// 			{docType: docs[formData.docType], doc: URL.createObjectURL(uploadedFile)},
// 			...prevDocs,
// 		]));

		let tmp = {
			...uploadedFile,
			msg: formData?.textArea,
		}
		setUploadedFile(tmp);
		let curDocs = await getFirestoreDoc(`/documents/${uid}`)
		const lastIdx = curDocs?.docs.length - 1;
		let lastDoc = curDocs?.docs[lastIdx]
		lastDoc.msg = formData?.msg;
		curDocs.docs[lastIdx].msg = formData?.textArea;
		console.log('curDocs', curDocs);
		setFirestoreDoc(`/documents/${uid}`, curDocs);
		


		setFormData( () => ( {
			docType: null,
			doc: null,
		}));
		setUploadedFile(null);
		console.log('updated Global form', globalForm)
		
	}

	function handleTextAreaChange(event) {
		setFormData({
			...formData,
			textArea: event.target.value,
		})		
	}


	const DocumentComponent = useCallback(({docType, url, fileNanoID, msg=null}) => {
		if (docType?.includes("childSchoolEnrollment")) {
			docType = 'childSchoolEnrollment';
		}
		else if (docType?.includes('childCourseCompletion')) {
			docType = 'childCourseCompletion';
		}
		else if (docType?.includes('other')) {
			docType = 'other'
		}

		function handleClick() {
			setIframeDoc(url);
			setIsIframe('pdf-viewer-fullscreen fade-in')
		}

		return (
			<div className='container'
			>
				<DragNDropBriefcase 
					text={docsList[docType]} 
					initialFileURL={url} 
					clickCallback={handleClick}  
					customStyle='pdf-viewer-small'
					fileNanoID={fileNanoID}
					doc={docType}
					documentsPage={true}
					msg={msg}
				/>
			</div>
		);
	}, [])

	return(
	<div>
	<FormContext.Provider value={{globalForm, setGlobalForm}}>
		<BackButton />
		<Spacer />
		<div className='form-div'>
			<h2 className='primary-title'>{lang.documents}</h2>
			<Spacer />
			<div>
				<Spacer />
				<h2 className='secondary-title centered-text'>{lang.newDoc}</h2>
				<Spacer />
				<div className=''>
					<Select
						options={docsAll.en_list}
						onChange={handleChange}
						classNamePrefix='form-text-item'
						className='large-select'
						styles={colorStyles}
					>
					</Select>
				</div>
				<Spacer10 />
			

		{
			formData.docType &&
			<div className='fade-in'>
			<center>
				<DragNDropBriefcase text={""} noGrow={true} uploadCallback={setUploadedFile} doc={formData.docType}/>
			</center>
				<Spacer10 />
				<div className='grid-column'>	
				<textarea className='text-area' placeholder={lang.optionalMessage} value={formData.textArea} onChange={handleTextAreaChange}></textarea>

					
				<button 
					className='larger-font form-action-btn'
					onClick={uploadDoc}
				>
					{lang.upload}	
				</button>
				</div>
				<Spacer />
			</div>
		}
			</div>
		
		<Spacer />
		{
// 			clientDocsState.length < 0 &&
			<h2 className='secondary-title centered-text'>{lang.uploadedDocs}</h2>
		}
		<Spacer />

		{
			isLoading? <LoadingDocs /> : 
			<div className='upload-grid from-div animated-div'>
			{
				globalForm.docs.slice().reverse().map((doc) => {
					console.log('doc', doc);
					return (
						<div key={nanoid()}className={uploadedFile === doc.url ? 'hidden' : ''}>
							<DocumentComponent docType={doc.docType} url={doc.url} fileNanoID={doc.uuid} msg={doc.msg}/>
						</div>
					)
				})
			}
			</div>
		}

		</div>
		</FormContext.Provider>
		<FullscreenDocument visible={isIframe} closeFunc={setIsIframe} src={iframeDoc} />
	</div>



	);
}
